/**
Author - Venkatesh Pullaganti
Git - https://github.com/venkatesh1146
**/

import UploadTwoSidedDocumentContainer from './UploadTwoSidedDoc.container';

export default UploadTwoSidedDocumentContainer;
